import type { ApiResponse , Client } from "../types/api.types";

import { collectCrmClientActivesMatchIds } from "./crmClientActivesUserId";
import { buildFetchItemsQuery } from "./legacy";

/**
 * Неархивные клиенты менеджера в CRM — id для фильтра ATON (`user_id` ≈ `client.id`, см. statistics).
 */
export function fetchCrmActiveClientIdsForManager(managerId: string | number): Promise<Set<number>> {
    return new Promise((resolve, reject) => {
        buildFetchItemsQuery(null, false, null, false)
            .where("manager_id", managerId)
            .all(
                (response: ApiResponse<any>) => {
                    const rows = (Array.isArray(response?.data) ? response.data : []) as Client[];
                    const ids = new Set<number>();
                    for (const c of rows) {
                        for (const id of collectCrmClientActivesMatchIds(c)) {
                            ids.add(id);
                        }
                    }
                    resolve(ids);
                },
                (err: any) => reject(err)
            );
    });
}
